<template>
	<span class="me-2">
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0.900024 4.64675L0.900024 15.209C0.900024 16.0202 1.61159 16.6779 2.48936 16.6779H15.5107C16.3885 16.6779 17.1 16.0202 17.1 15.209V4.64675C17.1 3.8355 16.3885 3.17786 15.5107 3.17786H2.48936C1.61159 3.17786 0.900024 3.8355 0.900024 4.64675Z"
				stroke="#585F66"
				stroke-width="1.5"
				stroke-linejoin="round"
			/>
			<path
				d="M4.73843 7.67793C4.10968 7.67793 3.59998 8.18764 3.59998 8.81638C3.59998 9.44513 4.10968 9.95483 4.73843 9.95483C5.36717 9.95483 5.87688 9.44513 5.87688 8.81638C5.87688 8.18764 5.36717 7.67793 4.73843 7.67793Z"
				fill="#585F66"
			/>
			<path
				d="M8.97256 7.67915C8.34381 7.67915 7.83411 8.18886 7.83411 8.8176C7.83411 9.44635 8.34381 9.95605 8.97256 9.95605C9.60131 9.95605 10.111 9.44635 10.111 8.8176C10.111 8.18886 9.60131 7.67915 8.97256 7.67915Z"
				fill="#585F66"
			/>
			<path
				d="M13.2082 7.67793C12.5794 7.67793 12.0697 8.18764 12.0697 8.81638C12.0697 9.44513 12.5794 9.95483 13.2082 9.95483C13.8369 9.95483 14.3466 9.44513 14.3466 8.81638C14.3466 8.18764 13.8369 7.67793 13.2082 7.67793Z"
				fill="#585F66"
			/>
			<path
				d="M4.73843 11.7928C4.10968 11.7928 3.59998 12.3025 3.59998 12.9313C3.59998 13.56 4.10968 14.0697 4.73843 14.0697C5.36717 14.0697 5.87688 13.56 5.87688 12.9313C5.87688 12.3025 5.36717 11.7928 4.73843 11.7928Z"
				fill="#585F66"
			/>
			<path
				d="M8.97378 11.7939C8.34503 11.7939 7.83533 12.3036 7.83533 12.9324C7.83533 13.5611 8.34503 14.0708 8.97378 14.0708C9.60253 14.0708 10.1122 13.5611 10.1122 12.9324C10.1122 12.3036 9.60253 11.7939 8.97378 11.7939Z"
				fill="#585F66"
			/>
			<path
				d="M13.2082 11.7928C12.5794 11.7928 12.0697 12.3025 12.0697 12.9313C12.0697 13.56 12.5794 14.0697 13.2082 14.0697C13.8369 14.0697 14.3466 13.56 14.3466 12.9313C14.3466 12.3025 13.8369 11.7928 13.2082 11.7928Z"
				fill="#585F66"
			/>
			<path
				d="M16.9951 5.49365H1.32208"
				stroke="#585F66"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
			/>
			<path
				d="M4.84113 3.45551V0.900024"
				stroke="#585F66"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
			/>
			<path
				d="M9.15857 3.45551V0.900024"
				stroke="#585F66"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
			/>
			<path
				d="M13.4772 3.45551V0.900024"
				stroke="#585F66"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
			/>
			<path
				d="M0.900024 5.87793L0.900024 4.41003C0.900024 3.72972 1.6118 3.17793 2.48936 3.17793L15.5107 3.17793C16.3883 3.17793 17.1 3.72972 17.1 4.41003V5.87793L0.900024 5.87793Z"
				fill="#585F66"
			/>
		</svg>
	</span>
</template>

<script>
export default {
	name: "CalendarIcon",
	props: {},
	computed: {},
};
</script>
